export default __webpack_public_path__ + "MUt_users.html";